// VIP 12 - Page 7: Study Completion
// 7-1. Study Completion Information
// Others (기타 의견)

import React from "react";

const Page7 = ({ formData, handleChange, handleCheckboxChange, dtDisplay }) => {
  // 라디오 버튼 전용 핸들러
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 재사용 가능한 라디오 필드 렌더링 함수
  const renderRadioField = (
    fieldName,
    label,
    options,
    isRequired = false,
    columnType = "2col"
  ) => {
    const wrapperClass =
      columnType === "1col" ? "input-wrapper-1column" : "input-wrapper-2column";
    const blockClass =
      columnType === "1col" ? "block-1column" : "block-2column";
    const titleClass =
      columnType === "1col" ? "item_title_1col" : "item_title_2col";
    const inputClass = columnType === "1col" ? "input_1col" : "input_2col";

    return (
      <div className={wrapperClass}>
        <div className={blockClass}>
          <label className={titleClass}>
            {label}
            {isRequired && <span className="required-mark"> *</span>}
          </label>
          <div className={inputClass}>
            <div className="rad-group">
              {options.map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name={fieldName}
                    value={option.value}
                    checked={formData[fieldName] === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 텍스트 입력 필드 렌더링 함수
  const renderTextField = (
    fieldName,
    label,
    placeholder = "",
    unit = "",
    isRequired = false,
    type = "text"
  ) => {
    return (
      <div className="block-2column">
        <label className="item_title_2col">
          {label}
          {isRequired && <span className="required-mark"> *</span>}
        </label>
        <div className="input_2col">
          <input
            type={type}
            name={fieldName}
            placeholder={placeholder}
            value={formData[fieldName] || ""}
            onChange={handleChange}
          />
          {unit && <span className="unit-text">{unit}</span>}
        </div>
      </div>
    );
  };

  return (
    <section className="vip-form-section">
      <h2 className="section-subtitle">Study Completion</h2>

      {/* 7-1. Study Completion Information */}
      <fieldset className="basic-info-fieldset">
        <legend>7-1. Study Completion Information</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Has patient completed the study?
            </label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="study_completion"
                      value={option.value}
                      checked={formData.study_completion === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          {renderTextField(
            "withdraw_date",
            "Date of withdrawal",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("withdraw_reason", "Reason of withdrawal")}
          {renderTextField(
            "completion_date",
            "Date of study completion",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>
      </fieldset>

      {/* Others (기타 의견) */}
      <fieldset className="basic-info-fieldset">
        <legend>Others</legend>

        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">Others</label>
            <div className="input_1col">
              <textarea
                name="others"
                value={formData.others || ""}
                onChange={handleChange}
                rows="5"
                style={{
                  width: "100%",
                  padding: "0.75rem",
                  border: "1px solid #e0d6c0",
                  borderRadius: "5px",
                  fontSize: "1rem",
                  backgroundColor: "#faf6f0",
                  resize: "vertical",
                  fontFamily: "inherit",
                }}
                placeholder="기타 의견이나 특이사항을 입력해주세요..."
              />
            </div>
          </div>
        </div>
      </fieldset>

      {/* 숨겨진 필드들 */}
      <div style={{ display: "none" }}>
        <input
          type="text"
          name="confirm"
          value={formData.confirm || "no"}
          readOnly
        />
        <input type="text" name="reboa" value={formData.reboa || ""} readOnly />
      </div>

      {/* 완료 메시지 */}
      <div
        style={{
          backgroundColor: "#d1ecf1",
          border: "1px solid #bee5eb",
          borderRadius: "8px",
          padding: "20px",
          margin: "20px 0",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#0c5460", marginBottom: "10px" }}>Completed!</h3>
        <p style={{ color: "#0c5460", margin: "0", fontSize: "16px" }}>
          All required information has been entered.
          <br />
          Click the "Save" button to save the data.
        </p>
        {formData.reboa && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              borderRadius: "5px",
              color: "#856404",
            }}
          >
            <strong>Randomization Group:</strong> {formData.reboa}
            {formData.timeOfRandomization && (
              <>
                <br />
                <strong>Randomization Time:</strong>{" "}
                {formData.timeOfRandomization}
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Page7;
